<!--Desktop Banner-->
<fgb-desktop-nav-banner [pageName]="'challenges.page.title' | translate" [imageName]="'challenges'"></fgb-desktop-nav-banner>

<!--Mobile Navigation-->
<div class="bg-primary d-lg-none mobile-header-background"></div>
<fgb-mobile-nav-menu [pageName]="'challenges.page.title' | translate"></fgb-mobile-nav-menu>
<div class="bages-achieve-wrapper mobile-page-content" [ngClass]="isClub1901 ? 'bg-1901-secondary' : 'bg-secondary'">
  <fgbcl-badge-achieved [showBannerBadges]="true"></fgbcl-badge-achieved>
</div>

<div class="mt-4">
  <fgbcl-scorecard-list-view [icon]="'chevron_right'" [showPlaceholder]="true"></fgbcl-scorecard-list-view>
</div>
